import StartView from "./views/StartView.vue"
import MaterialView from "./views/MaterialView.vue"
import BackpanelMaterialView from "./views/BackpanelMaterialView.vue";
import SinkView from "./views/SinkView.vue";
import HobCutoutView from "./views/HobCutoutView.vue";
import AccessoriesView from "./views/AccessoriesView.vue";
import SummaryView from "./views/SummaryView.vue";
import ThankyouView from "./views/ThankyouView.vue";
import WorktopView from "./views/WorktopView.vue";
import BackpanelView from "./views/BackpanelView.vue";

import { createRouter, createWebHashHistory } from "vue-router";
import { useState, useUI } from "./store";
import ProductFamilyView from "./views/ProductFamilyView.vue";
import FunctionalAreaView from "./views/FunctionalAreaView.vue";

// const { state } = useState();

function getCurrentLanguage() {    
    return (window as any)._language;
}

function setCurrentLanguage(lang: string) {
    (window as any)._language = lang;
} 

const routes = [
    {
        name: "Root",
        path: "/:lang(fi|sv|en|nb)?",
        children: [
            {
                name: "Start",
                path: "",
                component: StartView, // require("views/StartView").default,
                beforeEnter: () => {
                    if (useUI().ui && !useUI().ui.exitConfirmed && useState().state.dirty) {
                        useUI().ui.navigateToStartPopupOpen = true;

                        return false;
                    }
                }
            },
            {
                name: "ProductFamily",
                path: "family",
                component: ProductFamilyView
            },
            { 
                name: "Worktop", 
                path: ":family/worktop", 
                component: WorktopView,
                beforeEnter: (to: any, from: any, next: any) => {
                    if (to.params.family)
                        useState().state.productFamily = to.params.family;

                    if (useState().state.allowNewDesigner && !useUI().ui.productFamilySelectionComplete) {
                        next({ name: "ProductFamily" });
                        return true;
                    }

                    if (!useUI().ui || useState().state.allowNewDesigner && !useUI().ui.productFamilySelectionComplete)
                        return false;

                    next();
                }
            },
            { name: "Backpanel", path: "backpanel", component: BackpanelView },
            { name: "Decorative Panel", path: "decorative-panel", component: BackpanelView },
            {
                name: "Material",
                path: ":family/material",
                component: MaterialView,// require("views/MaterialView").default,
                beforeEnter: () => {
                    if (!useUI().ui || !useUI().ui.worktopSelectionsComplete)
                        return false;
                }
            },
            {
                name: "BackpanelMaterial",
                path: "backpanel-material",
                component: BackpanelMaterialView, // require("views/BackpanelMaterialView").default,
                beforeEnter: () => {
                    if (!useUI().ui || !useUI().ui.backpanelSelectionsComplete)
                        return false;
                }
            },
            {
                name: "Sink",
                path: ":family/sink",
                component: SinkView, //require("views/SinkView").default,
                beforeEnter: () => {
                    if (!useUI().ui || !useUI().ui.materialSelectionsComplete || !useUI().ui.worktopSelectionsComplete)
                        return false;
                }
            },
            {
                name: "HobCutout",
                path: ":family/hobcutout",
                component: HobCutoutView, //require("views/HobCutoutView").default,
                beforeEnter: () => {
                    if (!useUI().ui || 
                        !useUI().ui.sinkSelectionsComplete || 
                        !useUI().ui.materialSelectionsComplete || 
                        !useUI().ui.worktopSelectionsComplete)
                        return false;
                }
            },
            {
                name: "Functional area",
                path: ":family/functional-area",
                component: FunctionalAreaView,
                beforeEnter: () => {
                    const { ui } = useUI();
                    const { state } = useState();
                    if (!useUI().ui.functionalAreaAvailable || 
                        !useUI().ui || 
                        !useUI().ui.sinkSelectionsComplete || 
                        !useUI().ui.materialSelectionsComplete || 
                        !useUI().ui.worktopSelectionsComplete || 
                        !useUI().ui.hobcutoutSelectionsComplete)
                        return false;
                }
            },
            {
                name: "Accessories",
                path: ":family/accessories",
                component: AccessoriesView, //require("views/AccessoriesView").default,
                beforeEnter: () => {
                    if (!useUI().ui || 
                        !useUI().ui.hobcutoutSelectionsComplete || 
                        !useUI().ui.sinkSelectionsComplete || 
                        !useUI().ui.materialSelectionsComplete || 
                        !useUI().ui.worktopSelectionsComplete || 
                        (
                            useUI().ui.functionalAreaAvailable && 
                            !useUI().ui.functionalAreaSelectionsComplete
                        ))
                        return false;
                }
            },
            {
                name: "Summary",
                path: "summary",
                component: SummaryView, //require("views/SummaryView").default,
                beforeEnter: () => {
                    if (!useUI().ui ||
                        (useState().state.mode == "backpanel" && (!useUI().ui.backpanelSelectionsComplete || !useUI().ui.backpanelMaterialSelectionsComplete)) ||
                        (useState().state.mode == "worktop" && (!useUI().ui.hobcutoutSelectionsComplete || !useUI().ui.sinkSelectionsComplete || !useUI().ui.materialSelectionsComplete || !useUI().ui.worktopSelectionsComplete))) {
                        return false;
                    }
                }
            },
            {
                name: "Thankyou",
                path: "thankyou",
                component: ThankyouView, //require("views/ThankyouView").default,
                beforeEnter: () => {
                    if (!useUI().ui ||
                        (useState().state.mode == "backpanel" && (!useUI().ui.backpanelSelectionsComplete || !useUI().ui.backpanelMaterialSelectionsComplete)) ||
                        (useState().state.mode == "worktop" && (!useUI().ui.hobcutoutSelectionsComplete || !useUI().ui.sinkSelectionsComplete || !useUI().ui.materialSelectionsComplete || !useUI().ui.worktopSelectionsComplete)))
                        return false;
                }
            }
        ]
    },

    // Redirect unknown routes to start view
    // { path: "*", redirect: "/" },
    //{ path: "/:pathMatch(.*)*", redirect: "/" },
    
];

const router = createRouter({
    history: createWebHashHistory("designer"),
    linkActiveClass: "active",
    // base: "designer",
    // mode: "hash",
    routes,
});

router.beforeEach((to: any) => {
    const lang = to.params.lang as string | undefined;

    // If language missing, you can allow it and use default,
    // or redirect to explicit default language.
    if (!lang) {
        return { ...to, params: { ...to.params, lang: getCurrentLanguage() ?? "en" } };
    }
    else {
        setCurrentLanguage(lang);
    }

    // Example: store active language somewhere
    // useUI().ui.language = lang;
})


function useStore() {
    throw new Error("Function not implemented.");
}

export { router };